import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { HttpService } from '@/services/HttpService.ts';
import { identifyLogRocketUser } from '@/services/logrocket.ts';

export enum OnboardingStatus {
  DURING_REGISTRATION = 'DURING_REGISTRATION',
  KYC_PASSED = 'KYC_PASSED',
  COMPLETED = 'COMPLETED',
  KYC_FIRST_FAILED = 'KYC_FIRST_FAILED',
  KYC_FAILED = 'KYC_FAILED',
  KYC_FAILED_PENDING = 'KYC_FAILED_PENDING',
  KYC_FAILED_UPLOADED_DOCS = 'KYC_FAILED_UPLOADED_DOCS',
  KYB_PENDING = 'KYB_PENDING',
  KYB_FAILED_FINAL = 'KYB_FAILED_FINAL',
  KYC_FAILED_PARTNER = 'KYC_FAILED_PARTNER',
  KYC_FAILED_FINAL = 'KYC_FAILED_FINAL',
}

export interface AccountantDetails {
  accountantExternalId: string;
  email: string;
  firstName: string;
  lastName: string;
  firmName: string;
  referralCode: string;
  customerIds: string[] | null;
  defaultCustomerId: string | null;
  customerOnboardingStatus: OnboardingStatus | null;
}

const getAccountantDetails = async (accountantExternalId: string) => {
  const { data } = await HttpService.get<AccountantDetails>(
    `/v1/accountant/${encodeURIComponent(accountantExternalId)}/details`
  );
  return data;
};

export const accountantDetailsQueryOptions = (accountantExternalId: string) =>
  queryOptions({
    queryKey: ['accountant', 'details', accountantExternalId],
    queryFn: async () => {
      const data = await getAccountantDetails(accountantExternalId);
      identifyLogRocketUser(data.accountantExternalId);
      return data;
    },
  });

export const useAccountantDetails = (accountantExternalId: string) => {
  return useSuspenseQuery(accountantDetailsQueryOptions(accountantExternalId));
};
